import React, { useEffect, useState } from 'react';
import Loader from '../../general/Loader';
import { downloadFile, request } from '../../../utils/request';
import { formatCurrency } from '../../../utils/helpers';
import dayjs from 'dayjs';
import { auth } from '../../../utils/auth';

const calcularDiasCesantia = (years, months) => {
    return (years * (years >= 5 ? 23 : 21)) + (months >= 6 ? 13 : (months >= 3 ? 6 : 0));
}

const calcularProporcionVacaciones = (months) => {
    if (months >= 5) return months + 1;
    
    return 0;
}

const calCularPrestaciones = (empleado, termino, preaviso, cesantia, vacaciones, navidad) => {
    const start = dayjs(empleado.fechaIngreso || undefined);
    const end = dayjs(empleado.fechaSalida ? empleado.fechaSalida : termino);
    const inicioAnoActual = dayjs(new Date((new Date()).getFullYear(), 0, 1));
    const inicioPeriodoActual = start.isBefore(inicioAnoActual) ? inicioAnoActual : start;

    const years = end.diff(start, "year");
    const months = end.diff(start.add(years, "year"), "month");
    const days = end.diff(start.add(years, "year").add(months, "month"), "day");
    const diffMonths = end.diff(start, "month");
    const mesesDelPeriodoActualV = end.diff(inicioPeriodoActual, "month");
    const mesesDelPeriodoActualN = end.add(1, "day").diff(inicioPeriodoActual, "month");
    const diasDelPeriodoActualN = end.add(1, "day").diff(inicioPeriodoActual.add(mesesDelPeriodoActualN, "month"), "day");

    const sueldoDiario = empleado.sueldoFijo / 23.83;
    const preavisoDays = preaviso ? 0 : diffMonths >= 12 ? 28 : (diffMonths >= 6 ? 14 : (diffMonths >= 3 ? 7 : 0));
    const cesantiaDays = cesantia ? calcularDiasCesantia(years, months) : 0;
    const vacacionesDays = vacaciones ? calcularProporcionVacaciones(mesesDelPeriodoActualV) : (years >=5 ? 18 : (years >= 1 ? 14 : calcularProporcionVacaciones(months)));
    const navidadMeses = navidad ? mesesDelPeriodoActualN : 0;
    const navidadDias = navidad ? diasDelPeriodoActualN : 0;

    const preavisoAmount = sueldoDiario * preavisoDays;
    const cesantiaAmount = sueldoDiario * cesantiaDays;
    const vacacionesAmount = sueldoDiario * vacacionesDays;
    const navidadAmount = empleado.sueldoFijo * ((navidadMeses + (navidadDias / 31)) / 12);

    return {
        ...empleado,
        sueldoDiario,
        tiempoTrabajando: `${years} años, ${months} meses y ${days} días`,
        preavisoDays,
        preavisoAmount,
        cesantiaDays,
        cesantiaAmount,
        vacacionesDays,
        vacacionesAmount,
        navidadMeses,
        navidadDias,
        navidadAmount,
        prestacionesAmount: preavisoAmount + cesantiaAmount + vacacionesAmount + navidadAmount,
    };
};

const CalculoPrestaciones = () => {
    const [empleados, setEmpleados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [downloading, setDownloading] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const termino = queryParams.get('termino') || undefined;
    const preaviso = queryParams.get('preaviso') === "si";
    const cesantia = queryParams.get('cesantia') === "si";
    const vacaciones = queryParams.get('vacaciones') === "si";
    const navidad = queryParams.get('navidad') === "si";

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const getEmpleados = async () => {
        const response = await request(`empleados${window.location.search}`);

        if (response.data) {
            setEmpleados(response.data.map(empleado => calCularPrestaciones(empleado, termino, preaviso, cesantia, vacaciones, navidad)));
            setLoading(false);
        }
    };

    const downloadReport = async (name, type) => {
        setDownloading(true);

        await downloadFile(`reportes/calculo-prestaciones${window.location.search}&type=${type}`, `${name}.${type}`);
    
        setDownloading(false);
    };

    useEffect(() => {
        getEmpleados().then(() => {
            setTimeout(() => {
                window.print();
            }, 1000);
        });
    }, []);

    if (loading) {
        return <Loader />;
    }

    return <>
        <style>{`@page {size: A3 landscape}`}</style>
        <div className="ordernar-resultados no-print">
            <div className="form-group">
                {downloading && <Loader type="small" />}

                {!downloading && <>
                    <strong className="form-label m-r-15">Exportar:</strong>

                    <button className="btn btn-secondary m-r-15" onClick={() => {
                        downloadReport('calculo-prestaciones', 'xlsx');
                    }}>XLSX</button>

                    <button className="btn btn-secondary m-r-15" onClick={() => {
                        downloadReport('calculo-prestaciones', 'pdf');
                    }}>PDF</button>
                </>}
            </div>
        </div>

        <div>
            <div className='row'>
                <h2 className='col-md-12 text-center m-b-5'>
                    Cálculo de Prestaciones
                </h2>
                <div className='col-md-12 text-center'>
                    {sucursal.nombre} - {sucursal.direccion} •{" "}
                    {new Date().toLocaleString()}
                </div>
                <div className='col-md-12 text-center'>
                    <strong>Fecha de término:</strong> {dayjs(termino).format("DD/MM/YYYY")} |&nbsp;
                    <strong>Preaviso:</strong> {preaviso ? "Sí" : "No"} |&nbsp;
                    <strong>Cesantía:</strong> {cesantia ? "Sí" : "No"} |&nbsp;
                    <strong>Vacaciones:</strong> {vacaciones ? "Sí" : "No"} |&nbsp;
                    <strong>Navidad:</strong> {navidad ? "Sí" : "No"}
                </div>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-left'>
                        TOTAL EMPLEADOS: {empleados.length}
                    </div>

                    <div className='float-right'>
                        <h3>EMPLEADOS</h3>
                    </div>
                </div>
            </div>
            <table className='table m-b-40'>
                <thead>
                    <tr>
                        <th>Codigo</th>
                        <th>Nombre</th>
                        <th>Cédula</th>
                        <th>Cargo</th>
                        <th>Fecha de Ingreso</th>
                        <th>Tiempo Trabajando</th>
                        <th>Contrato</th>
                        <th>Estado</th>
                        <th className='text-right'>Sueldo Fijo</th>
                        <th className='text-right'>Sueldo Diario</th>
                        <th className='text-right'>Preaviso</th>
                        <th className='text-right'>Cesantía</th>
                        <th className='text-right'>Vacaciones</th>
                        <th className='text-right'>Navidad</th>
                        <th className='text-right'>Total Prestaciones</th>
                    </tr>
                </thead>
                <tbody>
                    {empleados.map((empleado) => {
                        return (
                            <tr key={empleado.id} style={{ textDecoration: empleado.active ? 'none' : 'line-through' }}>
                                <td>{empleado.codigo}</td>
                                <td>
                                    {empleado.nombre} {empleado.apellido}
                                </td>
                                <td>{empleado.cedula}</td>
                                <td>{empleado.cargo}</td>
                                <td>{dayjs(empleado.fechaIngreso || undefined).format('DD/MM/YYYY')}</td>
                                <td>{empleado.tiempoTrabajando}</td>
                                <td>
                                    {empleado.informal
                                        ? "Informal"
                                        : "Formal"}
                                </td>
                                <td>
                                    {empleado.active
                                        ? "Activo"
                                        : "Inactivo"}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.sueldoFijo)}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.sueldoDiario)}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.preavisoAmount)} {!preaviso && `(${empleado.preavisoDays} días)`}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.cesantiaAmount)} {cesantia && `(${empleado.cesantiaDays} días)`}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.vacacionesAmount)} {`(${empleado.vacacionesDays} días)`}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.navidadAmount)} {navidad && `(${empleado.navidadMeses} meses${empleado.navidadDias ? ` y ${empleado.navidadDias} días` : ''})`}
                                </td>
                                <td className='text-right'>
                                    {formatCurrency(empleado.prestacionesAmount)}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <th className='text-right' colSpan={10}>TOTAL</th>
                        <td className='text-right'>{formatCurrency(empleados.reduce((acc, empleado) => acc + empleado.preavisoAmount, 0))}</td>
                        <td className='text-right'>{formatCurrency(empleados.reduce((acc, empleado) => acc + empleado.cesantiaAmount, 0))}</td>
                        <td className='text-right'>{formatCurrency(empleados.reduce((acc, empleado) => acc + empleado.vacacionesAmount, 0))}</td>
                        <td className='text-right'>{formatCurrency(empleados.reduce((acc, empleado) => acc + empleado.navidadAmount, 0))}</td>
                        <td className='text-right'>{formatCurrency(empleados.reduce((acc, empleado) => acc + empleado.prestacionesAmount, 0))}</td>
                    </tr>
                </tfoot>
            </table>
            <div className='row'>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-left'>
                        TOTAL EMPLEADOS: {empleados.length}
                    </div>

                    <div className='float-right'>
                        <h3>EMPLEADOS</h3>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default CalculoPrestaciones;
